import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press15',
  templateUrl: './notice-press15.component.html',
  styleUrls: ['./notice-press15.component.scss']
})
export class NoticePress15Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
